// extracted by mini-css-extract-plugin
export default {"create-job-modal":"style_create-job-modal__QdbK4","createJobModal":"style_create-job-modal__QdbK4"};